import React from 'react';

const AllocationRec = ({ label, perc, color, currentPerc }) => (
  <div className="bg-slate-50 p-4 rounded-xl flex flex-col items-center justify-center text-center">
    <p className="text-2xl font-black text-[#041627]">{perc}</p>
    <p className="text-[10px] uppercase font-bold text-slate-400 tracking-wider">{label}</p>
    <div className={`h-1 w-8 mt-3 rounded-full ${color}`}></div>
    {currentPerc !== undefined && (
      <p className="text-[10px] font-semibold mt-2" style={{ color: color.includes('6bfe9c') ? '#006d37' : color.includes('red') ? '#ef4444' : '#94a3b8' }}>
        Actual: {currentPerc}
      </p>
    )}
  </div>
);

export default AllocationRec;